<template>
  <div>
    <table width="100%">
      <thead>
        <tr>
          <th>
            <my-header h1="Program Wise Entry Test Average Marks"></my-header>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <table border="1" width="100%" style="border-collapse: collapse; font-size: 12px">
              <tr>
                <th class="bg" align="left" width="20">Semester:</th>
                <td align="left" width="20">{{sess}}</td>
                <th class="bg" align="left" width="15">Degree:</th>
                <td align="left" width="15">{{deg}}</td>
                <th class="bg" align="left" width="20">Program:</th>
                <td align="left" width="20">{{pro}}</td>
              </tr>
              <tr>
                <th class="bg" align="left" width="20">Village/Town/City:</th>
                <td align="left" width="20">{{cit}}</td>
                <th class="bg" align="left" width="15">Category:</th>
                <td align="left" width="15">{{cat}}</td>
                <th class="bg" align="left" width="15">District:</th>
                <td align="left" width="15">{{dis}}</td>
              </tr>
              <tr>
                <th class="bg" align="left" width="15">Document Verified:</th>
                <td align="left" width="15" colspan="4">{{doc}}</td>
              </tr>
            </table>
            
            <table border="1" width="100%" style="border-collapse:collapse; font-size: 12px; margin-top:10px">
              <thead>
                <tr>
                  <th class="bg">Sr. No.</th>
                  <th class="bg">Program</th>
                  <th class="bg">Average Marks</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, ind) in data">
                  <td align="center">{{ind+1 }}</td>
                  <td>{{item.ProgramName}}</td>
                  <td align="right">{{getGrandTotal(item.TotalObtainedMarks,item.StudentCount)}}</td>
                </tr>
                <!--<tr>
                  <th class="bg" colspan="2">Total Amount</th>
                  <th class="bg" align="right">{{grandTotall}}</th>
                </tr>-->
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>


<script>
  const axios = require('axios').default;
  export default ({
    data() {
      return {
        data: [],
        sess: '',
        grandTotall: 0,
        pro: '',
        dep: '',
        deg: '',
        doc: '',
        dis:'',
        cat: '',
        cit: '',
      }
    },
    mounted: function () {
      this.pagePrint();
    },
    methods: {
      pagePrint() {
        var vm = this;
        axios.post('/api/AdmissionApi/getProgWiseEntryTestAverage')
          .then(function (res) {
            vm.data = res.data.lst2;
            vm.sess = res.data.sess;
            vm.pro = res.data.pro;
            vm.dep = res.data.dep;
            vm.deg = res.data.deg;
            vm.doc = res.data.doc;
            vm.dis = res.data.dis;
            vm.cit = res.data.cit;
            vm.cat = res.data.cat;
          })
      },
          getGrandTotal(marks, student) {
            if (marks == 0) {
          return 0;
        }
        else {
              return Math.round(marks / student);
        }
      }
    }
  })
</script>
<style>
  .bg {
    background-color: lightgrey;
  }
</style>



// WEBPACK FOOTER //
// src/components/onlineadmission/EntryTestAverageMarksPrint.vue